import styled from 'styled-components'

export const FAQContainer = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  grid-row-gap: 60px;
  padding: 15px;
  @media screen and (min-width: 1100px) {
    padding: 0px;
  }
`

export const FAQTitle = styled.h2`
  font-size: 20px;
  font-family: ${props => props.theme.font.family.bold};
  color: black;
  padding-top: 50px !important;
  @media screen and(min-width: 1100px) {

  }
`

export const FAQQuestion = styled.div`
  margin-top: -40px;
  display: grid;
  grid-row-gap: 25px;
  
  .rc-collapse-header{
    font-size: 15px !important;
  }
  @media screen and (min-width: 1100px) {

  }

`
